(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-custom-hero-ab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input',function(event){
  if(!event.target.matches('.tbcha-reveal-range'))return;
  event.target.closest('.tbcha-reveal').style.setProperty('--reveal',event.target.value+'%');
});
/* Wipe follows the cursor. Mouse only - touch keeps the range drag, and a
   coarse pointer has no hover state to follow. */
var TBCHA_REST=32, TBCHA_EASE=0.2;
var tbchaState=new WeakMap();

function tbchaSt(panel){
  var st=tbchaState.get(panel);
  if(!st){ st={target:TBCHA_REST,current:TBCHA_REST,rect:null,raf:0}; tbchaState.set(panel,st); }
  return st;
}
function tbchaApply(panel,st){
  panel.style.setProperty('--reveal',st.current.toFixed(2)+'%');
  var input=panel.querySelector('.tbcha-reveal-range');
  if(input)input.value=Math.round(st.current);
}
function tbchaTick(panel){
  var st=tbchaSt(panel);
  var delta=st.target-st.current;
  if(Math.abs(delta)<0.04){ st.current=st.target; tbchaApply(panel,st); st.raf=0; return; }
  st.current+=delta*TBCHA_EASE;          /* exponential smoothing, frame-rate led */
  tbchaApply(panel,st);
  st.raf=requestAnimationFrame(function(){tbchaTick(panel)});
}
function tbchaAim(panel,pct){
  var st=tbchaSt(panel);
  st.target=Math.min(92,Math.max(8,pct));
  if(!st.raf)st.raf=requestAnimationFrame(function(){tbchaTick(panel)});
}
/* Cache the box. Measuring inside pointermove forces a layout on every event. */
function tbchaMeasure(panel){ tbchaSt(panel).rect=panel.getBoundingClientRect(); }
addEventListener('resize',function(){
  document.querySelectorAll('.tbcha-reveal').forEach(tbchaMeasure);
},{passive:true});
addEventListener('scroll',function(){
  document.querySelectorAll('.tbcha-reveal').forEach(tbchaMeasure);
},{passive:true});

document.addEventListener('pointermove',function(event){
  if(event.pointerType&&event.pointerType!=='mouse')return;
  var panel=event.target.closest&&event.target.closest('.tbcha-reveal');
  if(!panel)return;
  var st=tbchaSt(panel);
  if(!st.rect||!st.rect.width)tbchaMeasure(panel);
  var box=st.rect;
  if(!box.width)return;
  panel.classList.add('is-tracking');
  tbchaAim(panel,((event.clientX-box.left)/box.width)*100);
},{passive:true});

/* On leave, hold position. The in-flight lerp still settles on the last cursor
   spot, so the wipe stops where the mouse left rather than springing back. */
document.addEventListener('mouseleave',function(event){
  var panel=event.target;
  if(!panel.classList||!panel.classList.contains('tbcha-reveal'))return;
  panel.classList.remove('is-tracking');
},true);

/* Touch: the range input only ever got taps, because the browser claims a drag
   as a scroll gesture. Decide from the first few px - mostly horizontal means
   wipe (and we preventDefault), mostly vertical means let the page scroll. */
var tbTouch=null;
document.addEventListener('touchstart',function(event){
  var panel=event.target.closest&&event.target.closest('.tbcha-reveal');
  if(!panel||event.touches.length!==1){tbTouch=null;return;}
  var t=event.touches[0];
  tbchaMeasure(panel);
  tbTouch={panel:panel,x0:t.clientX,y0:t.clientY,mode:0};
},{passive:true});

document.addEventListener('touchmove',function(event){
  if(!tbTouch||event.touches.length!==1)return;
  var t=event.touches[0];
  var dx=t.clientX-tbTouch.x0, dy=t.clientY-tbTouch.y0;
  if(tbTouch.mode===0){
    if(Math.abs(dx)<6&&Math.abs(dy)<6)return;         /* not enough to judge yet */
    tbTouch.mode=Math.abs(dx)>Math.abs(dy)?1:2;       /* 1 = wipe, 2 = scroll */
    if(tbTouch.mode===1)tbTouch.panel.classList.add('is-tracking');
  }
  if(tbTouch.mode!==1)return;
  if(event.cancelable)event.preventDefault();          /* keep the page still */
  var box=tbchaSt(tbTouch.panel).rect;
  if(!box||!box.width)return;
  tbchaAim(tbTouch.panel,((t.clientX-box.left)/box.width)*100);
},{passive:false});

document.addEventListener('touchend',function(){
  if(tbTouch&&tbTouch.panel)tbTouch.panel.classList.remove('is-tracking');
  tbTouch=null;
},{passive:true});

  } catch(e) { console.error(e); }
})();
})();
